module.exports = __webpack_public_path__ + "img/4.04db23c3.png";